import { render, staticRenderFns } from "./ItemSettingView.vue?vue&type=template&id=d33474ae&"
import script from "./ItemSettingView.vue?vue&type=script&lang=js&"
export * from "./ItemSettingView.vue?vue&type=script&lang=js&"
import style0 from "./ItemSettingView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports